import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, Paper, Grid, Card } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { spartaFaqs } from '../spartaFaqsData';

const isHtml = (str) => /<\/?[a-z][\s\S]*>/i.test(str);

const FaqNew = () => {
    const [expandedIndex, setExpandedIndex] = useState(null);

    return (
        <>
            <Card sx={{ padding: '5px' }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid size={{ md: 6, xs: 12 }}>
                        <Typography color="primary" fontSize="20px">FAQ's</Typography>
                    </Grid>
                </Grid>
            </Card>
            <Box style={{ margin: '20px 0px 0px 0px' }}>
                <Paper
                    className="lease-details-section"
                    style={{
                        height: `${window.innerHeight - 180}px`,
                        overflowY: 'auto',
                        padding: '10px',
                        marginTop: '10px',
                    }}
                >
                    {spartaFaqs.map((item, index) => {
                        const isExpanded = expandedIndex === index;
                        return (
                            <Box key={item.id}>
                                <Accordion
                                    expanded={isExpanded}
                                    onChange={() => setExpandedIndex(isExpanded ? null : index)}
                                    sx={{
                                        borderRadius: '0px',
                                        border: '1px solid rgba(0, 0, 0, 0.12)',
                                        boxShadow: 'none',
                                    }}
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls={`panel${index}-content`}
                                        id={`panel${index}-header`}
                                        sx={{
                                            margin: 0,
                                            minHeight: '48px',
                                            '&.Mui-expanded': { minHeight: '48px' },
                                            '.MuiAccordionSummary-content': { margin: 0 },
                                        }}
                                    >
                                        <Typography variant="h5" gutterBottom fontSize="15px">
                                            {item.question}
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ padding: 1, backgroundColor: 'rgb(246, 246, 246)' }}>
                                        <Typography
                                            component="div"
                                            sx={{
                                                background: 'rgb(246, 246, 246)',
                                                padding: 0,
                                                ...(isHtml(item.answer) && {
                                                    color: 'black',
                                                    fontSize: '14px',
                                                    lineHeight: 1.5,
                                                }),
                                            }}
                                            {...(isHtml(item.answer)
                                                ? { dangerouslySetInnerHTML: { __html: item.answer } }
                                                : { children: item.answer }
                                            )}
                                        />
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                        );
                    })}
                </Paper>
            </Box>
        </>
    );
};

export default FaqNew;
